/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PutApiV1TutoraiConfigPersonaMutationRequest,
  PutApiV1TutoraiConfigPersonaMutationResponse,
  PutApiV1TutoraiConfigPersona400,
  PutApiV1TutoraiConfigPersona401,
  PutApiV1TutoraiConfigPersona500,
} from "../../types/tutorAIConfigController/PutApiV1TutoraiConfigPersona.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { putApiV1TutoraiConfigPersona } from "../../clients/tutorAIConfigController/putApiV1TutoraiConfigPersona.ts";

export const putApiV1TutoraiConfigPersonaMutationKey = () =>
  [{ url: "/api/v1/tutorai/config/persona" }] as const;

export type PutApiV1TutoraiConfigPersonaMutationKey = ReturnType<
  typeof putApiV1TutoraiConfigPersonaMutationKey
>;

export function putApiV1TutoraiConfigPersonaMutationOptions<TContext = unknown>(
  config: Partial<
    RequestConfig<PutApiV1TutoraiConfigPersonaMutationRequest>
  > & { client?: Client } = {},
) {
  const mutationKey = putApiV1TutoraiConfigPersonaMutationKey();
  return mutationOptions<
    PutApiV1TutoraiConfigPersonaMutationResponse,
    ResponseErrorConfig<
      | PutApiV1TutoraiConfigPersona400
      | PutApiV1TutoraiConfigPersona401
      | PutApiV1TutoraiConfigPersona500
    >,
    { data?: PutApiV1TutoraiConfigPersonaMutationRequest },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return putApiV1TutoraiConfigPersona(data, config);
    },
  });
}

/**
 * @description Salva a persona. `isGlobal=true` substitui a persona global. `isGlobal=false` com `classStudentId` salva a persona da turma. **(Requer Authorization para autenticação)**
 * @summary Atualizar persona do assistente (Requer Authorization para autenticação)
 * {@link /api/v1/tutorai/config/persona}
 */
export function usePutApiV1TutoraiConfigPersona<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PutApiV1TutoraiConfigPersonaMutationResponse,
      ResponseErrorConfig<
        | PutApiV1TutoraiConfigPersona400
        | PutApiV1TutoraiConfigPersona401
        | PutApiV1TutoraiConfigPersona500
      >,
      { data?: PutApiV1TutoraiConfigPersonaMutationRequest },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PutApiV1TutoraiConfigPersonaMutationRequest>
    > & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? putApiV1TutoraiConfigPersonaMutationKey();

  const baseOptions = putApiV1TutoraiConfigPersonaMutationOptions(
    config,
  ) as UseMutationOptions<
    PutApiV1TutoraiConfigPersonaMutationResponse,
    ResponseErrorConfig<
      | PutApiV1TutoraiConfigPersona400
      | PutApiV1TutoraiConfigPersona401
      | PutApiV1TutoraiConfigPersona500
    >,
    { data?: PutApiV1TutoraiConfigPersonaMutationRequest },
    TContext
  >;

  return useMutation<
    PutApiV1TutoraiConfigPersonaMutationResponse,
    ResponseErrorConfig<
      | PutApiV1TutoraiConfigPersona400
      | PutApiV1TutoraiConfigPersona401
      | PutApiV1TutoraiConfigPersona500
    >,
    { data?: PutApiV1TutoraiConfigPersonaMutationRequest },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PutApiV1TutoraiConfigPersonaMutationResponse,
    ResponseErrorConfig<
      | PutApiV1TutoraiConfigPersona400
      | PutApiV1TutoraiConfigPersona401
      | PutApiV1TutoraiConfigPersona500
    >,
    { data?: PutApiV1TutoraiConfigPersonaMutationRequest },
    TContext
  >;
}
